import { SVGProps } from "react"

import { IconProps } from "../nav-icons/icon.types.ts"

export const IconDataTransfer = ({ hovered, ...props }: IconProps) => {
  if (hovered) return <DataTransferHover {...props} />
  else return <DataTransferDefault {...props} />
}

const DataTransferDefault = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="data_transfer_default_svg__Calque_2"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 32 32"
    xmlSpace="preserve"
    {...props}
  >
    <style>
      {
        ".data_transfer_default_svg__st0{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}"
      }
    </style>
    <path
      className="data_transfer_default_svg__st0"
      d="M24.5 22H7M11.4 26.3 7 22l4.6-4.5M7 10h17.5M20.2 5.6l4.3 4.4-4.5 4.5"
    />
  </svg>
)

const DataTransferHover = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    xmlSpace="preserve"
    {...props}
  >
    <path
      fill="currentColor"
      d="M25.4 5H6.6C5.7 5 5 5.7 5 6.6v18.9c0 .8.7 1.5 1.6 1.5h18.9c.9 0 1.6-.7 1.6-1.6V6.6C27 5.7 26.3 5 25.4 5zm-4.2 15.4h-9.4l1.6 1.6c.2.2.2.6 0 .9 0 .1-.2.1-.3.1-.2 0-.3-.1-.4-.2L10 20.1c-.2 0-.2-.1-.2-.1-.1-.1-.1-.2-.1-.2 0-.2.1-.3.2-.4l2.9-2.8c.2-.2.6-.2.9 0 .2.2.2.6 0 .9L12 19.2h9.4c.4 0 .6.2.6.6s-.4.6-.8.6zm.7-8.2c0 .1 0 .2-.1.2s-.1.1-.1.2l-2.8 2.8c-.1.1-.3.2-.4.2-.1 0-.3-.1-.4-.2-.2-.2-.2-.6 0-.9l1.7-1.7h-9.4c-.4 0-.6-.2-.6-.6 0-.4.2-.6.6-.6h9.4l-1.6-1.7c-.2-.2-.2-.6 0-.9s.6-.2.9 0l2.7 2.7s0 .1.1.1l.1.1c-.1.2-.1.2-.1.3z"
    />
  </svg>
)
